const m = window.require("@ember/owner");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;